export default __webpack_public_path__ + "static/media/download1.6cee69ee.jpg";